// extracted by mini-css-extract-plugin
module.exports = {"inspirational":"Grid_inspirational__d8Dfd","standard":"Grid_standard__g9V3s","overview":"Grid_overview__2LdZ_","grid":"Grid_grid__BZHmS"};